import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Card, Container } from "reactstrap";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import { CommonButton } from "components/Common/ButtonCommon";
import httpService from "services/httpService";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { toastrCRUDSuccess } from "components/Common/AlertToastr";
import { TEXT_POST, TEXT_PUT } from "helpers/name_helper";

const NewTemplate = () => {
  const [modelOptions, setModelOptions] = useState([]);
  const [isSignature, setIsSignature] = useState(false);
  const { id } = useParams();

  const schema = yup.object({}).required();

  const includeFunctions = {
    model: {
      options: modelOptions,
    },
    Signature: {
      onChange: e => setIsSignature(e.target.checked),
    },
  };

  useEffect(async () => {
    const res = await httpService.get("/parse/schemas", {
      headers: {
        "X-Parse-Master-Key": "LASDK106JKHR87SDFJSDHF0DFHASFDF",
      },
    });
    const options = _.orderBy(
      res.results.map(({ className }, index) => ({
        index,
        name: className,
        value: className,
      })),
      ["name"],
      ["asc"]
    );
    setModelOptions(options);
  }, []);

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { renderForm, content, getContent } = useGetFormSchema(
    "Template",
    yup,
    rest,
    errors
  );

  useEffect(async () => {
    if (!id) return;

    try {
      const url = "/parse/classes/Template/" + id;
      const response = await httpService.get(url);
      const { reset } = rest;

      if (!response.content.includes("<body")) {
        reset({ ...response });
        getContent({ ...response });
        return;
      }

      const contentSplitStart = response.content.split("<body");
      const contentSplitEnd = contentSplitStart[1].split("</body>");

      const content = ("<body" + contentSplitEnd[0] + "</body>").replaceAll(
        "figure",
        "div"
      );

      reset({ ...response });
      getContent({ ...response, content });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const onSubmit = async values => {
    const { createdAt, updatedAt, ...template } = values;

    const contentString = `<!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Document</title>
        <style>
          body {
            margin: auto;
            width: 75%;
            height: 0%;
          }
    
          .center {
            text-align: center;
          }
        </style>
      </head>
      ${content}
    </html>
    `;
    if (id) {
      httpService.put(`/parse/classes/Template/${id}`, {
        ...template,
        content: contentString,
      });
      toastrCRUDSuccess("Template", TEXT_PUT);

      return;
    }
    httpService.post("/parse/classes/Template", {
      ...template,
      content: contentString,
    });
    toastrCRUDSuccess("Template", TEXT_POST);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <HeaderCreateItem title={id ? "Chi tiết Template" : "Thêm Template"}>
            <CommonButton level={0}>Lưu</CommonButton>
          </HeaderCreateItem>
          {renderForm([], includeFunctions)}
        </form>
      </Container>
    </div>
  );
};

export default NewTemplate;
